package nl.volleyplanner.web.controller.planner

import kotlinx.html.TagConsumer
import kotlinx.html.div
import kotlinx.html.h1
import kotlinx.html.js.div
import nl.volleyplanner.web.base.component
import nl.volleyplanner.web.base.component.ListeningComponent
import nl.volleyplanner.web.controller.thuisprogramma.AbstractThuisprogrammaComponent
import nl.volleyplanner.web.controller.thuisprogramma.ChangesBehindPublishedComponent
import nl.volleyplanner.web.controller.thuisprogramma.ThuisProgrammaEditorControlsComponent
import nl.volleyplanner.web.controller.thuisprogramma.version_selector.ThuisProgrammaVersionSelectorComponent
import nl.volleyplanner.web.controller.thuisprogramma.ThuisprogrammaComponent
import nl.volleyplanner.web.controller.thuisprogramma.ThuisprogrammaDataManager
import org.w3c.dom.HTMLElement

class ThuisProgrammaEditorComponent(
    thuisprogrammaDataManager: ThuisprogrammaDataManager
) : AbstractThuisprogrammaComponent(thuisprogrammaDataManager.problemSlug, thuisprogrammaDataManager) {

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.div {
            h1 (classes = "display-5 d-print-none") { +"Planning bewerken" }
            component(ThuisProgrammaVersionSelectorComponent(problemSlug, thuisprogrammaDataManager))
            component(ThuisProgrammaEditorControlsComponent(problemSlug, thuisprogrammaDataManager))

            component(ListeningComponent(
                "ProblemEditorContentSelectorComponent", listOf(
                    thuisprogrammaDataManager.problemData.selectedProblemVersionSlugState
                )
            ) {
                val selectedProblemVersionSlug = thuisprogrammaDataManager.problemData.selectedProblemVersionSlugState.value
                div {
                    div {
                        component(
                            ChangesBehindPublishedComponent(
                                thuisprogrammaDataManager,
                                problemSlug,
                                selectedProblemVersionSlug
                            )
                        )
                    }

                    div {
                        component(
                            ThuisprogrammaComponent(
                                problemSlug,
                                selectedProblemVersionSlug,
                                thuisprogrammaDataManager
                            )
                        )
                    }
                }
            })

        }
    }

    override suspend fun getState() = null
}